import React from 'react'

interface Props {}

export function Logo(props: Props) {
    const {} = props

    return (
        <div style={{padding: '1em 0.5em 0.5em', borderTop: '1px solid #CFD4DF'}}>
         <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
            {/* <a> */}
                 <img src={`${process.env.PUBLIC_URL}/assets/logo/usaid.png`} alt={'Usaid'} style={{width: '120px'}}/> 
            {/* </a>   
             <a > */}
                 <img src={`${process.env.PUBLIC_URL}/assets/logo/ucsd.png`} alt={'UCSD'}  style={{width: '120px'}}/>
             {/* </a> */}
         </div>

         <p style={{fontSize: '11px', color: 'rgba(0,0,0,0.45)', margin: 0, padding: '0.5em'}}>
            Цю інтерактивну візуалізацію підготовлено за підтримки Агентства США з міжнародного розвитку (USAID), наданої від імені народу Сполучених Штатів Америки за підтримки Програми Уряду Великої Британії «Good Governance Fund», наданої від імені народу Великої Британії. Відповідальність за зміст цієї схеми, яка необов'язково відображає погляди USAID, Уряду Сполучених Штатів Америки, UK aid або Уряду Великої Британії, несе виключно компанія ТОВ «Делойт Консалтинг» в рамках контракту №72012118C00001.     
        </p>   
        
        </div>
    )
}

